// extracted by mini-css-extract-plugin
export default {"wrapper":"TakeawayOrdersMinutesCounter_wrapper__t1mNG"};